// extracted by mini-css-extract-plugin
export default {"table-empty":"TableEmpty_table-empty__y4y4r","table-empty__content":"TableEmpty_table-empty__content__iDhJV"};